module.exports = __webpack_public_path__ + "static/media/foreign-contacts.7b350704.svg";